import {Injectable} from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import {AuthService} from '../core/services/auth.service';
import {FuseConfigService} from '../core/services/config.service';
import { Location } from '@angular/common';
import {accessRightMenu} from './accessRights';


@Injectable()
export class AuthGuard  {
  role;
  privacy;
  canRecommend;
  accessRight = accessRightMenu;

  constructor (private router: Router , private auth: AuthService , fuseConfig: FuseConfigService, private location: Location) {
    this.privacy = localStorage.getItem('privacy');
    fuseConfig.role.subscribe((res) => {
      this.role = res;
    });
    fuseConfig.canRecommend.subscribe((res) => {
      this.canRecommend = res;
    });
    fuseConfig.privacy.subscribe((res) => {
      this.privacy = res;
      console.log(res);
      // this.privacy = true;
    });
  }


  canActivate (route: ActivatedRouteSnapshot , state: RouterStateSnapshot) {
    console.log(this.privacy);
    // console.log(route, state, 'URLRL');
    let url = '';
    if (route.url[ route.url.length - 1 ].path === 'new' || route.url[ route.url.length - 1 ].path === 'detail') {
      url = route.url[ route.url.length - 2 ].path + '_' + route.url[ route.url.length - 1 ].path;
    } else {
      url = route.url[ route.url.length - 1 ].path;
    }
    if (this.auth.isLoggedIn && localStorage.getItem('accessToken') && this.accessRight[ this.role ].includes(url)) {
      // logged in so return true
      if (this.privacy === 'true' || this.privacy === true) {
        if ((url === 'recommendEvent' || url === 'recommendBlog' || url === 'recommendElearning' ) && !this.canRecommend) {
          this.router.navigate([ '/pages/auth/login' ] , {queryParams: {returnUrl: state.url}});
          return false;
        }
        return true;
      } else {
        this.router.navigate([ '/pages/privacy' ] , {queryParams: {returnUrl: state.url}});
        return false;
      }
    }
    // not logged in so redirect to login page with the return url
    this.router.navigate([ '/pages/auth/login' ] , {queryParams: {returnUrl: state.url}});
    // this.location.back();
    return false;
  }
}
